import clsx from "clsx";
import styles from "./Button.module.less";

import Demyst from "../../views/assets/Demyst.svg";

export const Button = ({
  autoWidth = false,
  demystIcon = false,
  hidden,
  onClick,
  variant = "primary",
  size = "lg",
  disabled,
  type,
  children,
  className,
  noStyle = false,
  ...props
}) => {
  const classesArray = [
    "Button",
    styles.Button,
    variant === "inverted" && styles.Inverted,
    variant === "secondary" && styles.Secondary,
    variant === "secondary-alt" && styles.Secondary_alt,
    hidden && styles.Hidden,
    autoWidth === true && styles.AutoWidth,
    size === "hero" && styles.Size_lg,
    size === "lg" && styles.Size_lg,
    size === "md" && styles.Size_md,
    size === "sm" && styles.Size_sm,
    disabled && styles.Disabled,
    className,
  ];

  const classes = noStyle !== true ? clsx(classesArray) : className;

  return (
    <button
      type={type}
      className={classes}
      onClick={e => {
        onClick && onClick(e);
      }}
      {...props}
    >
      {noStyle !== true ? <span>{children}</span> : children}
      {demystIcon && <img src={Demyst.src} alt="" width="16" height="22" loading="eager" />}
    </button>
  );
};
